import apiClient from './apiClient';

export interface CreateVitalsRequest {
    residentId: string;
    dailyBloodPressure: string;
    dailyBloodSugar: string;
    dailyWeight: string;
    mealPortion: string;
    bowelMovement: string;
    temperature: string;
    pulseRate: string;
    respirationRate: string;
    spO2: string;
    painLevel: string;
    levelOfConsciousness: string;
    vitalDate: string;
}

const NEW_BASE_URL = '/v1/EMR-vitals';

class VitalsService {
    async createVitals(data: CreateVitalsRequest): Promise<any> {
        const response = await apiClient.post(NEW_BASE_URL, data);
        return response.data;
    }

    async getVitals(residentId: string): Promise<any[]> {
        const response = await apiClient.get(`${NEW_BASE_URL}/resident/${residentId}`);
        return response.data;
    }

    async getLatestVitals(residentId: string): Promise<any> {
        const response = await apiClient.get(`${NEW_BASE_URL}/resident/${residentId}/latest`);
        return response.data;
    }

    async updateVitals(id: string, data: Partial<CreateVitalsRequest>): Promise<any> {
        const response = await apiClient.put(`${NEW_BASE_URL}/${id}`, data);
        return response.data;
    }

    async deleteVitals(id: string): Promise<void> {
        await apiClient.delete(`${NEW_BASE_URL}/${id}`);
    }
}

const vitalsService = new VitalsService();
export default vitalsService;
